import type { InMemoryAdditionalCompensation } from 'modules/contracts/lib/contractFlowContext'

import { AdditionalCompensationCard } from '../AdditionalCompensationCard/AdditionalCompensationCard'

type AdditionalCompensationsListProps = {
  additionalCompensations: InMemoryAdditionalCompensation[]
  onEdit?: (additionalCompensation: InMemoryAdditionalCompensation) => void
  onDelete?: (additionalCompensation: InMemoryAdditionalCompensation) => void
  onRead?: (additionalCompensation: InMemoryAdditionalCompensation) => void
}

function AdditionalCompensationsList({
  additionalCompensations,
  ...crudCallbacks
}: AdditionalCompensationsListProps) {
  return additionalCompensations.map((additionalCompensation) => {
    return (
      <AdditionalCompensationCard
        key={
          additionalCompensation.tmpID !== undefined
            ? `tmp-${additionalCompensation.tmpID}`
            : `id-${additionalCompensation.id}`
        }
        {...additionalCompensation}
        {...crudCallbacks}
      />
    )
  })
}

export { AdditionalCompensationsList }
